// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';

import dashboardReducer from './dashboardSlice';
import carReducer from './carSlice';
import userReducer from './userSlice';
import tripReducer from './tripSlice';
import couponReducer from './couponSlice';
import fareReducer from './fareSlice';
import authReducer from './authSlice';
import paymentReducer from './paymentSlice';
import financeReportReducer from './financeReportSlice';
import driverReducer from './driverSlice';

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'], // Only persist auth state
  blacklist: ['dashboard', 'cars', 'users', 'trips', 'coupons', 'fares', 'payments', 'financeReports', 'drivers'] // Don't persist these
};

// Auth-specific persist config for more granular control
const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['user', 'token', 'isAuthenticated'] // Only persist essential auth data
};

// Combine reducers
const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  dashboard: dashboardReducer,
  cars: carReducer,
  users: userReducer,
  trips: tripReducer,
  coupons: couponReducer,
  fares: fareReducer,
  payments: paymentReducer,
  financeReports: financeReportReducer,
  drivers: driverReducer
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with middleware for redux-persist
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/PAUSE', 'persist/PURGE', 'persist/REGISTER']
      }
    })
});

// Create persistor
export const persistor = persistStore(store);
